<template>
  <div class="phone" :class="getBg()">
    <img class="imgs" src="@/assets/img/Jump.png" v-show="isWX && platform === 'android'" width="300" height="110" alt="">
    <div class="andUr">
      <div class="header-container isFixed">
        <div class="header-inner">
          <img class="logo" src="@/assets/img/dashboard/logo.png" />
          <span class="title">图枢</span>
        </div>
      </div>
      <div class="all">
        <div style="margin-top: 110px;">
          <img src="@/assets/img/dashboard/logo.png" />
          <div class="team">图枢</div>
        </div>
        <el-button class="downAnd" @click.stop="downAnd()" :disabled="isWX" v-show="platform === 'android'">
          <img src="@/assets/img/link/android.png" width="20px" height="20px" alt="">
          <span style="position: relative;top: -2px;">下载Android客户端</span>
        </el-button>
        <el-button class="downAnd" @click.stop="downIos()" v-show="platform == ''">
          <img src="@/assets/img/link/iOS.png" width="20px" height="20px" alt="">
          <span style="position: relative;top: -2px;">下载iPhone客户端</span>
        </el-button>
        <div class="imglist">
          <img v-for="(item,i) in imgList" :key="i" :src="item.url" width="25px" height="25px" alt="">
          <div class="downurl">支持 iOS，Android，Windows，macOS系统</div>
        </div>
      </div>
      <footer>
        Copyright©2021 紫光云技术有限公司 津 ICP 备 19004759号-1津公网安备 12019202000336号
      </footer>
    </div>
  </div>
</template>

<script>
import { getLastPublishVersionByCode } from '@/api/dashboard'
export default {
  name: 'mobileDownload',
  data() {
    return{
      isWX: false,
      loadList: [],
      andr: [],
      iPhone: '',
      platform: '',
      imgList: [
        {url: require('@/assets/img/ios.png')},
        {url: require('@/assets/img/andriod.png')},
        {url: require('@/assets/img/window.png')},
        {url: require('@/assets/img/mac.png')}
      ]
    }
  },
  created () {
    this.getMobile()
  },
  methods: {
    getMobile() {
      let nua = navigator.userAgent.toLowerCase()
      this.isWX = nua.match(/MicroMessenger/i) == 'micromessenger'
      this.platform = navigator.userAgent.match(/Android/i) != null ? 'android' : ''
      this.getDownList()
    },
    getBg() {
      if (this.isWX && this.platform === 'android') return 'andClass'
    },
    downAnd() {
      let url = this.andr[0].apkFileUrl
      let name = `teamlink${this.andr[0].version}.apk`
      let link = document.createElement('a')
      link.href = url
      link.style.display = 'none'
      link.setAttribute('download', name)
      document.body.appendChild(link)
      link.click()
    },
    downIos() {
      window.location.href = this.iPhone
    },
    download() {
      if (this.platform === 'android' && !this.isWX) {
        let url = this.andr[0].apkFileUrl
        let name = `teamlink${this.andr[0].version}.apk`
        let link = document.createElement('a')
        link.href = url
        link.style.display = 'none'
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
      } else if (!this.platform) {
        window.location.href = this.iPhone
      }
    },
    async getDownList() {
      let that = this
      let res = await getLastPublishVersionByCode({ code: 'teamlink' })
      if (res.code === '200') {
        this.loadList = res.data
        let and = [],ios = ''
        this.loadList.map(item => {
          if (item.typeId === 1) {
            and.push(item)
          } else if (item.typeId === 2) {
            ios = item.apkFileUrl
          }
        })
        this.andr = and
        this.iPhone = ios
        setTimeout(() => {
          that.download()
        },200)
      } else {
        this.$message.warning(res.msg)
      }
    },
  }
}
</script>

<style scoped lang="scss">
  .andClass{
    background: #000;
    opacity: 0.5;
  }
  .phone{
    height: 100%;
    width: 100%;
    .imgs{
      z-index: 99999;
      position: absolute;
      right: 0;
    }
  }
  .andUr{
    width: 100%;
    height: 100%;
  }
  .header-container {
    width: 100%;
    height: 63px;
    line-height: 63px;
    position: relative;
    text-align: center;
  }
  .isFixed {
    position: fixed;
    box-shadow: 0 1px 3px rgba(0,0,0,.1);
    top: 0;
    left: 0;
    color: #0085dd;
    background: #fff;
    border-bottom: 1px solid #ebebeb;
    .header-inner {
      width: 1000px;
      margin: 0 auto;
      color: #fff;
    }
    .logo,
    .title {
      float: left;
    }
  .logo {
    width: 36px;
    margin: 15px 15px 0 15px;
    color: #2053cd;
    border-color: #2053cd;
  }
  .title {
    border-color: #2053cd;
    color: #2053cd;
    font-size: 25px;
  }
  }
  .all {
    padding-top: 63px;
    text-align: center;
    height: calc(100% - 100px);
    background: #F0F2F5;
    .team{
      font-size: 20px;
      color: #333333;
    }
    .downAnd{
      display: inline-block;
      width: 183px;
      height: 42px;
      text-align: center;
      background: #2053cd;
      border-radius: 21px;
      font-size: 12px;
      color: #FFFFFF;
      margin-top: 16px;
      img{
        vertical-align: text-bottom;
        margin-right: 10px;
      }
    }
    .imglist{
      margin-top: 30px;
      img{
        margin: 0 10px;
      }
      .downurl{
        font-size: 12px;
        color: #4B5863;
        text-align: center;
        line-height: 17px;
        margin-top: 15px;
      }
    }
  }
  footer {
    min-height: 75px;
    color: #fff;
    position: fixed;
    bottom: 0;
    font-size: 12px;
    text-align: center;
    background: #1c1f37;
    word-break: break-all;
    padding: 25px 15px;
    line-height: 25px;
  }
</style>
